// Google Analytics + Meta Pixel tracking utilities

export const trackPageView = (url) => {
  // GA4
  if (window.gtag) {
    window.gtag('config', 'G-QQDBQNDKX8', { page_path: url });
  }
  // Meta Pixel
  if (window.fbq) {
    window.fbq('track', 'PageView');
  }
};

export const trackEvent = (eventName, params = {}) => {
  // GA4 custom event
  if (window.gtag) {
    window.gtag('event', eventName, params);
  }
  // Meta Pixel custom event
  if (window.fbq) {
    window.fbq('trackCustom', eventName, params);
  }
};

// Pre-defined events
export const trackCTAClick = (ctaName, destination) => {
  trackEvent('cta_click', { cta_name: ctaName, destination });
};

export const trackContactFormSubmit = () => {
  trackEvent('contact_form_submit');
  if (window.fbq) {
    window.fbq('track', 'Lead');
  }
};

export const trackBookSession = () => {
  trackEvent('book_session');
  if (window.fbq) {
    window.fbq('track', 'Schedule');
  }
};
